// tslint:disable
export enum NoteAggregateType {
    /**
     * @description User
     */
    User = 0,
}
(NoteAggregateType as any)['USER'] = 0;
